import I18n from 'utils/I18n';

// eg. given,
//  "urls": {
//     "100": "https://photo_url_1",
//     "1800": "https://photo_url_2"
// }
// returns https://photo_url_2
export const getPhotoWithMaxDimension = (photoUrlHash) => {
  const key = Object.keys(photoUrlHash).reduce((a, b) => (a > b ? a : b));
  return photoUrlHash[key];
};

// Takes Time Tag and converts displayed time to time ago from current time
// ex) <time class="timeago" datetime="2021-07-17T00:53:01Z">3 days ago</time>
// returns <time class="timeago" datetime="2021-07-17T00:53:01Z">July 17, 2021</time>
export const buildTimeAgoTimestamp = (timestamp) => {
  const timestampParsed = new DOMParser()
    .parseFromString(timestamp, 'text/html')
    .body.querySelector('time')
    .getAttribute('datetime');
  const timeToReplace = new DOMParser()
    .parseFromString(timestamp, 'text/html')
    .body.querySelector('time').innerHTML;
  const timeAgo = I18n.timespanFormatter().constructor.timeago(
    Date.parse(timestampParsed)
  );
  return timestamp.replace(timeToReplace, timeAgo);
};

export const isDev = () => {
  return !process.env.NODE_ENV || process.env.NODE_ENV === 'development';
};

export const devLog = (string) => {
  if (isDev()) {
    // eslint-disable-next-line no-console
    console.log(string);
  }
};

export const roundUpNearest10 = (num) => {
  const n = num < 1 ? 1 : num;
  return Math.ceil(n / 10) * 10;
};

export default {
  getPhotoWithMaxDimension,
  buildTimeAgoTimestamp,
  devLog,
  isDev
};
